/**
 * Visible RatingPrompt chrome per page language. Only what the seeker reads is
 * translated: a reason chip still submits its English label as feedback text,
 * because tag_feedback_themes.py keyword-codes that text (resultReasons.ts).
 */
export type RatingLanguage = "en" | "hi";

export const RATING_COPY = {
  en: {
    thanks: "Thank you",
    helpful: "Helpful",
    notHelpful: "Not helpful",
    whatFeltOff: "What felt off?",
    tellUsMore: "Tell us more (optional)",
    submit: "Submit",
    npsScale: "0 to 10 recommend scale",
    npsLow: "Not likely",
    npsHigh: "Very likely",
    reasonLabels: {} as Readonly<Record<string, string>>,
  },
  hi: {
    thanks: "धन्यवाद",
    helpful: "उपयोगी",
    notHelpful: "उपयोगी नहीं",
    whatFeltOff: "क्या ठीक नहीं लगा?",
    tellUsMore: "और बताएं (वैकल्पिक)",
    submit: "भेजें",
    npsScale: "0 से 10 तक सुझाने की संभावना",
    npsLow: "संभावना नहीं",
    npsHigh: "पूरी संभावना",
    reasonLabels: {
      inaccurate: "परिणाम गलत लगता है",
      score_wrong: "स्कोर गलत लगता है",
      confusing: "समझना मुश्किल",
      wanted_more: "और विस्तार चाहिए",
      wanted_remedies: "उपाय चाहिए थे",
      unexpected: "जैसा सोचा था वैसा नहीं",
    } as Readonly<Record<string, string>>,
  },
} as const;

export type RatingCopy = (typeof RATING_COPY)[RatingLanguage];
